import { render, staticRenderFns } from "./modalChangeUserPicture.vue?vue&type=template&id=5b9440d1&"
import script from "./modalChangeUserPicture.vue?vue&type=script&lang=js&"
export * from "./modalChangeUserPicture.vue?vue&type=script&lang=js&"
import style0 from "./modalChangeUserPicture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports